/**
 * Hands a fetched blob to the browser's downloader.
 *
 * An object URL and a synthetic click is still the only way: the file arrives
 * over an authenticated request, so it can't be a plain `<a href>` the way the
 * Vaadin `ADocumentService` anchor worked.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
